import { Suspense, lazy } from "react";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Calculator from "@/components/Calculator";
import Benefits from "@/components/Benefits";
import ComoFunciona from "@/components/ComoFunciona";
import LeadFormDialog from "@/components/LeadFormDialog";
import LazySection from "@/components/LazySection";
import SectionSkeleton from "@/components/SectionSkeleton";

const FAQ = lazy(() => import("@/components/FAQ"));
const FinalCTA = lazy(() => import("@/components/FinalCTA"));
const Footer = lazy(() => import("@/components/Footer"));

const Index = () => {
  return (
    <div className="min-h-screen">
      <Header />
      <Hero />
      <Calculator />
      <Benefits />
      <ComoFunciona />
      <LazySection fallback={<SectionSkeleton tone="light" />}>
        <Suspense fallback={<SectionSkeleton tone="light" />}>
          <FAQ />
        </Suspense>
      </LazySection>
      <LazySection fallback={<SectionSkeleton tone="dark" />}>
        <Suspense fallback={<SectionSkeleton tone="dark" />}>
          <FinalCTA />
        </Suspense>
      </LazySection>
      <LazySection fallback={<SectionSkeleton tone="dark" />}>
        <Suspense fallback={<SectionSkeleton tone="dark" />}>
          <Footer />
        </Suspense>
      </LazySection>
      <LeadFormDialog />
    </div>
  );
};

export default Index;
